import React, { useState, useRef } from 'react';
import { Button, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CSSTransition } from 'react-transition-group';

import { criteria, criteria_tooltips, default_tooltip_show, default_tooltip_hide } from '../Consts';

import './Evaluation.css';

const EvaluationPerformMultipleTableCollapsible = ({ parentState, evalData, overallStats }) => {
    const [openTb, setOpenTb] = useState(false);
    const [openCp, setOpenCp] = useState(false);

    const nodeRefTb = useRef(null);
    const nodeRefCp = useRef(null);
    const nodeRefs = useRef([]);

    const edArr = evalData;
    const data = edArr[0][0];
    const protoExam = edArr[0][1];

    const checkForCritB = (cp) => {
        let retVal = false;
        Object.keys(cp).map((key) => {
            cp[key].map((item) => {
                if (Number(item) > 40) {
                    retVal = true;
                }
            })
        })
        return retVal;
    }

    return (
        <>
            <div className="pb-3">
                <Button
                    variant="outline-primary"
                    size="sm"
                    className="p-1 mb-2"
                    onClick={() => setOpenTb(!openTb)}
                    aria-controls="collapseTable"
                    aria-expanded={openTb}
                >
                    {openTb ? "Detailansicht ausblenden" : "Detailansicht einblenden"}
                </Button>

                {/* {openTb && (
                    <> */}
                <CSSTransition
                    nodeRef={nodeRefTb}
                    in={openTb}
                    timeout={750}
                    classNames="details-table"
                    unmountOnExit
                >
                    <Table ref={nodeRefTb} bordered hover responsive className="" id="singleEvalTable">
                        <tbody>

                            {parentState.criterion_b === "yes" &&
                                <>
                                    <tr>
                                        <td colSpan={data.numTasks + 1} className="p-0 border-0">
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                className="p-1 my-3"
                                                onClick={() => setOpenCp(!openCp)}
                                                aria-controls="collapseCp"
                                                aria-expanded={openCp}
                                            >
                                                {openCp ? `Abweichung bei ${criteria[1]} ausblenden` : `Abweichung bei ${criteria[1]} einblenden`}
                                            </Button>
                                        </td>
                                        <td colSpan={2} className="border-0"></td>
                                    </tr>

                                    <CSSTransition
                                        key="cp-table-header"
                                        nodeRef={nodeRefCp}
                                        timeout={500}
                                        in={openCp}
                                        classNames="details-table"
                                        unmountOnExit
                                    >
                                        <tr ref={nodeRefCp}>
                                            <td>&nbsp;</td>
                                            {protoExam.taskNames[0].slice(2).map((aufgabe, index) => (
                                                <td key={index} className="text-center">{aufgabe.value}</td>
                                            ))}
                                            <td colSpan={2} className="border-0"></td>
                                        </tr>
                                    </CSSTransition>

                                    {edArr.map((ed, index) => {
                                        const data = ed[0];
                                        const exam = ed[1];
                                        return (
                                            <React.Fragment key={index}>
                                                {checkForCritB(data.crossProducts) && (
                                                    nodeRefs.current[index] = React.createRef(),
                                                    <>
                                                        <CSSTransition
                                                            key={`cp-table-class-row-${index}`}
                                                            nodeRef={nodeRefs.current[index]}
                                                            timeout={500}
                                                            in={openCp}
                                                            classNames="details-table"
                                                            unmountOnExit
                                                        >
                                                            <tr ref={nodeRefs.current[index]}>
                                                                <td colSpan={data.numTasks + 3} className="text-center fs-5 border-0">
                                                                    <span className="bold">{exam.klasse}</span>_{exam.fach}_{exam.schuljahr}
                                                                </td>
                                                            </tr>
                                                        </CSSTransition>
                                                        {Object.keys(data.crossProducts).map((key, mainindex) => (
                                                            nodeRefs.current[nodeRefs.current.length] = React.createRef(),
                                                            <React.Fragment key={mainindex}>

                                                                <CSSTransition
                                                                    key={`cp-table-class-${index}-row-${mainindex}`}
                                                                    nodeRef={nodeRefs.current[nodeRefs.current.length]}
                                                                    timeout={500}
                                                                    in={openCp}
                                                                    classNames="details-table"
                                                                    unmountOnExit
                                                                >
                                                                    <tr ref={nodeRefs.current[nodeRefs.current.length]}>
                                                                        {data.crossProducts[key].map((item, index) => (
                                                                            <React.Fragment key={index}>
                                                                                {index === 0 ? (
                                                                                    <td className="text-center">{item}</td>
                                                                                ) : item > 40 ? (
                                                                                    <OverlayTrigger
                                                                                        key={`overlay-${index}`}
                                                                                        delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                                                        overlay={
                                                                                            <Tooltip id={`tooltip-${index}`} className="eval-critB-tooltip">
                                                                                                {criteria_tooltips[1]}
                                                                                            </Tooltip>
                                                                                        }
                                                                                    >
                                                                                        <td key={`td-${index}`} className="pointerHelp text-center fw-bold colorCritBBG">{item}%</td>
                                                                                    </OverlayTrigger>
                                                                                ) : (
                                                                                    <td key={`td-${index}`}>&nbsp;</td>
                                                                                )}
                                                                            </React.Fragment>
                                                                        ))}
                                                                        <td colSpan={2} className="border-0 border-end"></td>
                                                                    </tr>
                                                                </CSSTransition>
                                                            </React.Fragment>
                                                        ))}
                                                    </>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                    <CSSTransition
                                        key="cp-table-bottom"
                                        nodeRef={nodeRefs.current[data.length]}
                                        timeout={500}
                                        in={openCp}
                                        classNames="details-table"
                                        unmountOnExit
                                    >
                                        <tr ref={nodeRefs.current[data.length]}><td colSpan={data.numTasks + 3} className='emptyTableRow'
                                            style={{ backgroundColor: "white" }}>&nbsp;</td></tr>
                                    </CSSTransition>
                                </>
                            }

                            <tr>
                                <td className="text-center fw-bold">Stufe</td>
                                {protoExam.abereiche[0].slice(2).map((abereich, index) => (
                                    <td key={index} className="border-0 text-center">{abereich.value}</td>
                                ))}
                                <td colSpan="2" className="border-0 border-end"></td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">Aufgaben</td>
                                {protoExam.taskNames[0].slice(2).map((aufgabe, index) => (
                                    <td key={index} className="text-center">{aufgabe.value}</td>
                                ))}
                                <td className="text-center fw-bold">Summe</td>
                                <td className="border-0 border-end"></td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">rel. Abstand</td>
                                {overallStats.aRelDistance.map((relDist, index) => (
                                    <React.Fragment key={index}>
                                        {relDist > 20 ? (
                                            <OverlayTrigger
                                                key={`overlay-relDist-${index}`}
                                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                overlay={
                                                    <Tooltip id={`tooltip-relDist-${index}`} className="eval-critC-tooltip">
                                                        {criteria_tooltips[2]}
                                                    </Tooltip>
                                                }
                                            >
                                                <td key={`td-relDist-${index}`} className="text-center pointerHelp colorCritCBG fw-bold">{relDist}%</td>
                                            </OverlayTrigger>
                                        ) : (
                                            <td key={`td-relDist-${index}`} className="text-center">{relDist}%</td>
                                        )}
                                    </React.Fragment>
                                ))}
                                <td colSpan="2" className="border-0 border-end"></td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">Punkte</td>
                                {protoExam.maxPunkte[0].slice(2).map((punkte, index) => (
                                    <td key={index} className="text-center">{punkte.value}</td>
                                ))}
                                <td className="border-0 border-end"></td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">L&ouml;sungsgrad</td>
                                {overallStats.aDegOfSolution.map((degree, index) => (
                                    <React.Fragment key={index}>
                                        {(degree > 80 || degree < 20) ? (
                                            <OverlayTrigger
                                                key={`overlay-degree-${index}`}
                                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                overlay={
                                                    <Tooltip id={`tooltip-degree-${index}`} className="eval-critA-tooltip">
                                                        {criteria_tooltips[0]}
                                                    </Tooltip>
                                                }
                                            >
                                                <td key={`td-degree-${index}`} className="pointerHelp text-center colorCritABG fw-bold text-white">{degree}%</td>
                                            </OverlayTrigger>
                                        ) : (
                                            <td key={`td-degree-${index}`} className="text-center">{degree}%</td>
                                        )}
                                    </React.Fragment>
                                ))}
                                <td className="text-center">{overallStats.avgDegOfSolution}%</td>
                                <td className="text-center fw-bold">Ergebnis</td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">Mittelwert</td>
                                {overallStats.aAverage.map((avg, index) => (
                                    <td key={index} className="text-center">{avg}</td>
                                ))}
                                <td className="text-center">{overallStats.sumAverage}</td>
                                <td className="text-center">{overallStats.percentageAverage}%</td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">Max</td>
                                {overallStats.aMaxVals.map((max, index) => (
                                    <React.Fragment key={index}>
                                        {max < protoExam.maxPunkte[0][index + 2].value ? (
                                            <OverlayTrigger
                                                key={`overlay-max-${index}`}
                                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                overlay={
                                                    <Tooltip id={`tooltip-max-${index}`} className="eval-maxpoints-pupil-tooltip">
                                                        Bei dieser Aufgabe wurde die volle Punktzahl nicht erreicht.
                                                    </Tooltip>
                                                }
                                            >
                                                <td key={`td-max-${index}`} className="bgBlue text-center pointerHelp">{max}</td>
                                            </OverlayTrigger>
                                        ) : (
                                            <td key={`td-max-${index}`} className="text-center">{max}</td>
                                        )}
                                    </React.Fragment>
                                ))}

                                {(overallStats.maxValPupil < overallStats.maxPoints) ? (
                                    <OverlayTrigger
                                        key={"mpPupils"}
                                        delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                        overlay={
                                            <Tooltip id="tooltip-max-pupils" className="eval-maxpoints-pupil-tooltip">
                                                Die maximale Punktzahl wurde nicht erreicht.
                                            </Tooltip>
                                        }
                                    >
                                        <td className="text-center bgBlue pointerHelp">{overallStats.maxValPupil}</td>
                                    </OverlayTrigger>
                                ) : (
                                    <td className="text-center">{overallStats.maxValPupil}</td>
                                )}
                                <td>{overallStats.percentageMaxVals}%</td>
                            </tr>

                            {edArr.map((ed, index) => {
                                const data = ed[0];
                                const exam = ed[1];

                                return (
                                    <React.Fragment key={index}>
                                        <tr>
                                            <td colSpan={data.numTasks + 3} className="text-center fs-5 border-0">
                                                <span className="fw-bold">{exam.klasse}</span>_{exam.fach}_{exam.schuljahr}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="fw-bold text-center">L&ouml;sungsgrad</td>
                                            {data.aDegOfSolution.map((degree, index) => (
                                                <React.Fragment key={index}>
                                                    {degree > 80 || degree < 20 ? (
                                                        <OverlayTrigger
                                                            key={`overlay-degree-${index}`}
                                                            delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                            overlay={
                                                                <Tooltip id={`tooltip-${index}`} className="eval-critA-tooltip">
                                                                    {criteria_tooltips[0]}
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <td key={`td-degree-${index}`} className="text-center pointerHelp colorCritABG fw-bold text-white">{degree}%</td>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <td key={`td-degree-${index}`} className="text-center">{degree}%</td>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                            <td></td>
                                            <td className="text-center fw-bold">Ergebnis</td>
                                        </tr>

                                        <tr>
                                            <td className="text-center fw-bold">Mittelwert</td>
                                            {data.aAverage.map((avg, index) => (
                                                <td key={index} className="text-center">{avg}</td>
                                            ))}
                                            <td className="text-center">{data.sumAverage}</td>
                                            <td className="text-center">{data.percentageAverage}%</td>
                                        </tr>

                                        <tr>
                                            <td className="text-center fw-bold">Max</td>
                                            {data.aMaxVals.map((max, index) => (
                                                <React.Fragment key={index}>
                                                    {max < exam.maxPunkte[0][index + 2].value ? (
                                                        <OverlayTrigger
                                                            key={`overlay-max-${index}`}
                                                            delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                            overlay={
                                                                <Tooltip id={`tooltip-max-${index}`} className="eval-maxpoints-pupil-tooltip">
                                                                    Bei dieser Aufgabe wurde die volle Punktzahl nicht erreicht.
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <td key={`td-max-${index}`} className="bgBlue pointerHelp text-center">{max}</td>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <td key={`td-max-${index}`} className="text-center">{max}</td>
                                                    )}
                                                </React.Fragment>
                                            ))}

                                            {(data.maxValPupil < overallStats.maxPoints) ? (
                                                <OverlayTrigger
                                                    key={"mpPupils"}
                                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                    overlay={
                                                        <Tooltip id="tooltip-max-pupils" className="eval-maxpoints-pupil-tooltip">
                                                            Die maximale Punktzahl wurde nicht erreicht.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <td className="bgBlue text-center pointerHelp">{data.maxValPupil}</td>
                                                </OverlayTrigger>
                                            ) : (
                                                <td className="text-center">{data.maxValPupil}</td>
                                            )}
                                            <td>{data.percentageMaxVals}%</td>
                                        </tr>

                                    </React.Fragment>
                                );
                            })}

                        </tbody>
                    </Table>
                </CSSTransition>
                {/* </>
                )} */}
            </div>
        </>
    );
}
export default EvaluationPerformMultipleTableCollapsible;
